import { clientMount } from '@vp/ubik-fragment-react';
import { Fragment } from '../fragments/logomaker';
import type { MountWithRootOptions } from '@vp/ubik-fragment-types';
import type { Props } from '../fragments/logomaker';

export const mount: MountWithRootOptions<Props> = async (rootElement, renderProps, rootOptions) => {
    return clientMount(<Fragment {...renderProps} />, rootElement, rootOptions);
};
